import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileValidationService {
  // Mime to extension mapping
  private mimeToExtension: { [key: string]: string } = {
    'image/jpeg': '.jpg',
    'image/png': '.png',
    'image/gif': '.gif',
    'image/webp': '.webp',
    'audio/mpeg': '.mp3',
    'audio/webm': '.webm',
    'application/ogg': '.ogg',
    'video/mp4': '.mp4',
    'video/webm': '.webm',
    'application/pdf': '.pdf',
    'application/msword': '.doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
    'application/vnd.ms-excel': '.xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
    'application/vnd.oasis.opendocument.spreadsheet': '.ods',
    'application/vnd.oasis.opendocument.text': '.odt',
    'application/csv': '.csv',
    'text/csv': '.csv',
  };

  /**
   * Checks if the file type is supported based on mime type.
   * @param file The file to validate
   * @returns boolean - true if type exists in mapping, false otherwise
   */
  validateFileType(file: File): boolean {
    if (!file || !file.type) {
      return false;
    }
  
    // Extract the base MIME type (before any semicolon and parameters)
    const baseMimeType = file.type.split(';')[0].trim();
    // Check if the base MIME type exists in the mapping
    return !!this.mimeToExtension[baseMimeType];
  }
}